module.exports = __webpack_public_path__ + "static/cinammon-9cbc701116663e0bab90f7cc2d017a0f.jpg";